import React from 'react'

import { useTranslations } from 'next-intl'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './SignupPageHeader.module.css'

interface SignupPageHeaderProps {
  title?: string
  summary?: any
}

const SignupPageHeader = ({ title, summary }: SignupPageHeaderProps) => {
  const t = useTranslations()
  return (
    <div className={styles.base}>
      <Container>
        {/* Main Intro */}
        <div className={styles.baseIntroContainer}>
          <Text size={TextSizes.primaryTitleLrg} className={styles.mainTitle}>
            {title || t('auth.signUpFree')}
          </Text>
          <div className={styles.introContainer}>
            <Text size={TextSizes.bodyMed} className={styles.mainSubTitle}>
              {t('auth.alreadyHaveAccount')}
            </Text>
            <Button
              variant={ButtonVariants.textLinkSmallUnderline}
              link="/login"
              className={styles.mainSubtitleLink}
            >
              {t('auth.login')}
            </Button>
          </div>
          {typeof summary === 'string' ? (
            <Text
              size={TextSizes.secondaryTitleLrg}
              className={styles.introText}
            >
              {summary || t('auth.signupDescription')}
            </Text>
          ) : summary ? (
            <BlockContent value={summary} size={TextSizes.secondaryTitleLrg} />
          ) : (
            <Text
              size={TextSizes.secondaryTitleLrg}
              className={styles.introText}
            >
              {t('auth.signupDescription')}
            </Text>
          )}
        </div>
      </Container>
    </div>
  )
}

export default SignupPageHeader
